// extracted by mini-css-extract-plugin
export var label = "_jq-0";
export var treatmentCard = "_jq-1";